export const ROUTES = {
  home: "/",
  projects: "/#projects",
  skills: "/#skills",
  projectDetails: "/projects/:id",
};
